import { Link } from "react-router-dom";

export const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="brand-logo-link"
    className="flex items-center gap-2.5 group"
    aria-label="EY 58 Group — Laman Utama"
  >
    <span className="relative inline-flex">
      <svg
        width="38"
        height="42"
        viewBox="0 0 38 42"
        fill="none"
        aria-hidden="true"
        className="transition-transform duration-300 group-hover:scale-105"
      >
        <path
          d="M19 1.5 34.5 7.5v11c0 9.8-6.6 17.4-15.5 21-8.9-3.6-15.5-11.2-15.5-21v-11L19 1.5Z"
          fill="url(#eyGold)"
          stroke="#B8962E"
          strokeWidth="1"
        />
        <path
          d="M19 5.2 31 9.9v8.7c0 7.9-5.1 14.2-12 17.4-6.9-3.2-12-9.5-12-17.4V9.9l12-4.7Z"
          fill="#0A192F"
        />
        <text
          x="19"
          y="24.5"
          textAnchor="middle"
          fill="#D4AF37"
          fontFamily="Plus Jakarta Sans, sans-serif"
          fontWeight="800"
          fontSize="11"
        >
          58
        </text>
        <defs>
          <linearGradient id="eyGold" x1="3" y1="2" x2="35" y2="40">
            <stop stopColor="#F3E5AB" />
            <stop offset="0.55" stopColor="#D4AF37" />
            <stop offset="1" stopColor="#B8962E" />
          </linearGradient>
        </defs>
      </svg>
    </span>
    <span
      className={`font-heading font-bold text-lg leading-tight tracking-tight ${
        dark ? "text-white" : "text-navy"
      }`}
    >
      EY 58 <span className="text-gold">Group</span>
    </span>
  </Link>
);
